/**
 * Created by Simon Zhao on 04/24/2022.
 * The models associate with note automation dialog.
 * ------ maintenance history ------
 */
import { KeyValue } from '@angular/common';
import { AutomationMappingItem, AutomationNoteMappingModel } from '../../../../tamalelibs/models/automation.model';
import { ControlType } from '../../../../tamalelibs/models/template-control.model';
import { COMMON_DELIMITER } from '../../../../tamalelibs/services/array-helper.service';
import { MultiSelDropdownFilterConfig } from '../../../multi-sel-dropdown-filter/multi-sel-dropdown-filter.model';
import * as _lodash from 'lodash';
import { AutomationActionType } from '../../diagram-context-menu/diagram-context-menu.model';

export class AutomationMappingItemViewModel {

    applicableFieldTypes: Array<ControlType> = [];

    applicableSystemVariables: Array<KeyValue<string, string>> = [];

    /**
    * the data source of field candiates for multiple selection.
    */
    dataSourceForMultipleSelection?: MultiSelDropdownFilterConfig = new MultiSelDropdownFilterConfig();

    /**
     * the data source of field candidates for single selection.
     */
    dataSourceForSingleSelection?: Array<KeyValue<string, string>>;

    /**
     * the source field, unique id.
     */
    fieldInTemplate: string;

    /**
     * A function being called when a template field is clicked.
     */
    click?: (field: AutomationMappingItemViewModel) => void;

    /**
     * the mapping target fields.
     */
    fieldsInWorkflow: KeyValue<string, string> | Array<KeyValue<string, string>>;

    /**
    * a flag indicating whether current mapping item is deletable.
    */
    isDeletable: boolean;

    /**
     * a flag indicating whether current mapping should be loaded defaultly.
     */
    isPreloaded: boolean;

    nameOfFieldInTemplate: string;

    /**
     * a flag indicating whether a multiple selection control should generate for this item.
     */
    isMultipleSelection: boolean;

    /**
     * a flag indicating whether the task submitters should be part of candidate list.
     */
    isTaskSubmitterIncluded?: boolean;

    static toAutomationItem(src: AutomationMappingItemViewModel) {
        const result = new AutomationMappingItem();
        const extractFieldsInWorkflowFunc = () => {
            if (src.isMultipleSelection) {
                return src.dataSourceForMultipleSelection.data.filter(fItem => fItem.checked).map(r => r.id).join(COMMON_DELIMITER);
            } else {
                return Array.isArray(src.fieldsInWorkflow) ? src.fieldsInWorkflow.map(f => f.value).join(COMMON_DELIMITER) : src.fieldsInWorkflow.value;
            }
        };
        result.fieldInTemplate = src.fieldInTemplate;
        result.fieldInWorkflow = extractFieldsInWorkflowFunc();
        return result;
    }
}

export class DiagramNoteAutomationDialogResult {
    isConfirmed: boolean;
    mappingResult: AutomationNoteMappingModel;
    nodeId: string;
    isUpdate: boolean;
}

export class DiagramNoteAutomationDialogOptions {
    existingMapping?: AutomationNoteMappingModel;
    isUpdate: boolean;
    nodeId: string;
    taskArray: Array<KeyValue<string, string>>;
    type: AutomationActionType;

    static toViewModelArray(options: DiagramNoteAutomationDialogOptions, references: Array<AutomationMappingItemViewModel>): Array<AutomationMappingItemViewModel> {
        const vmArray = [];
        if (options && options.isUpdate && options.existingMapping) {
            options.existingMapping.mapping.forEach(
                it => {
                    const vm = new AutomationMappingItemViewModel();
                    vm.fieldInTemplate = it.fieldInTemplate;
                    const refVm = references.find(refIt => refIt.fieldInTemplate === vm.fieldInTemplate);
                    if (refVm) {
                        const singleDs = _lodash.cloneDeep(refVm.dataSourceForSingleSelection);
                        const multipleDs = _lodash.cloneDeep(refVm.dataSourceForMultipleSelection);
                        const extractFieldNameFunc = (id: string) => {
                            if (refVm.dataSourceForSingleSelection && refVm.dataSourceForSingleSelection.length > 0) {
                                return refVm.dataSourceForSingleSelection.find(vmItem => vmItem.value === id);
                            }

                            return null;
                        };
                        if (refVm.isMultipleSelection) {
                            const matchKVPairs = [];
                            it.fieldInWorkflow.split(COMMON_DELIMITER).forEach(fldId => {
                                const matchKS = extractFieldNameFunc(fldId);
                                if (matchKS) {
                                    matchKVPairs.push(matchKS);
                                    const matchDsItem = multipleDs.data.find(f => f.id === matchKS.value);
                                    if (matchDsItem) {
                                        matchDsItem.checked = true;
                                    }
                                }
                            });

                            vm.fieldsInWorkflow = matchKVPairs;
                        } else {
                            const matchRef = extractFieldNameFunc(it.fieldInWorkflow);
                            if (matchRef) {
                                vm.fieldsInWorkflow = extractFieldNameFunc(it.fieldInWorkflow);
                            } else {
                                // the reference field maybe deleted.
                                vm.fieldsInWorkflow = null;
                            }
                        }
                        vm.applicableFieldTypes = refVm.applicableFieldTypes;
                        vm.dataSourceForSingleSelection = singleDs;
                        vm.dataSourceForMultipleSelection = multipleDs;
                        vm.isMultipleSelection = refVm.isMultipleSelection;
                        vm.isDeletable = refVm.isDeletable;
                        vm.isPreloaded = refVm.isPreloaded;
                        vm.nameOfFieldInTemplate = refVm.nameOfFieldInTemplate;

                        vmArray.push(vm);
                    }
                }
            );
        }

        return vmArray;
    }
}


